module.exports = __webpack_public_path__ + "images/emoji/lemon.c2b73e1396c9f0220f7f.png";